import { PanToolOutlined as PanToolOutlinedIcon } from '@mui/icons-material';

const RaisedHandOutlined = (): JSX.Element => <PanToolOutlinedIcon fontSize="inherit" />;

export default RaisedHandOutlined;
